"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaqueBleedingIndexTeeth_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PlaqueBleedingIndexExam_1 = require("./PlaqueBleedingIndexExam");
var PlaqueBleedingIndexTeeth_Factory = /** @class */ (function () {
    function PlaqueBleedingIndexTeeth_Factory() {
    }
    PlaqueBleedingIndexTeeth_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Bleeding: model.Bleeding,
            IsMissing: model.IsMissing,
            Plaque: model.Plaque,
            PlaqueBleedingIndexExam: PlaqueBleedingIndexExam_1.PlaqueBleedingIndexExam_Factory.CreateIncoming(model.PlaqueBleedingIndexExam),
            PlaqueBleedingIndexExamId: model.PlaqueBleedingIndexExamId,
            Position: model.Position,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ToothString: model.ToothString,
        };
        return result;
    };
    PlaqueBleedingIndexTeeth_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Bleeding: model.Bleeding,
            IsMissing: model.IsMissing,
            Plaque: model.Plaque,
            PlaqueBleedingIndexExam: PlaqueBleedingIndexExam_1.PlaqueBleedingIndexExam_Factory.CreateOutgoing(model.PlaqueBleedingIndexExam),
            PlaqueBleedingIndexExamId: model.PlaqueBleedingIndexExamId,
            Position: model.Position,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ToothString: model.ToothString,
        };
        return result;
    };
    return PlaqueBleedingIndexTeeth_Factory;
}());
exports.PlaqueBleedingIndexTeeth_Factory = PlaqueBleedingIndexTeeth_Factory;
